// extracted by mini-css-extract-plugin
export default {"root":"mU3FCp7LJ60f0MA52_9B","inbox":"XpkRUCRqZKI1gwzvWlnQ","title":"_hRA68PUI1TsZJIWTwrQ","text":"fdiphMSFl4h9JyD_gvFc"};